/*
 Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Gallery API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SystemPermission = 'CreateCollections' | 'ViewCollections' | 'EditCollections' | 'ManageCollections' | 'CreateExhibits' | 'ViewExhibits' | 'EditExhibits' | 'ManageExhibits' | 'ViewUsers' | 'ManageUsers' | 'ViewRoles' | 'ManageRoles' | 'ViewGroups' | 'ManageGroups';

export const SystemPermission = {
    CreateCollections: 'CreateCollections' as SystemPermission,
    ViewCollections: 'ViewCollections' as SystemPermission,
    EditCollections: 'EditCollections' as SystemPermission,
    ManageCollections: 'ManageCollections' as SystemPermission,
    CreateExhibits: 'CreateExhibits' as SystemPermission,
    ViewExhibits: 'ViewExhibits' as SystemPermission,
    EditExhibits: 'EditExhibits' as SystemPermission,
    ManageExhibits: 'ManageExhibits' as SystemPermission,
    ViewUsers: 'ViewUsers' as SystemPermission,
    ManageUsers: 'ManageUsers' as SystemPermission,
    ViewRoles: 'ViewRoles' as SystemPermission,
    ManageRoles: 'ManageRoles' as SystemPermission,
    ViewGroups: 'ViewGroups' as SystemPermission,
    ManageGroups: 'ManageGroups' as SystemPermission
};

